export default (set, get, choices) => set(
  () => ({
    choicesInfo: choices
  }),
  false,
  { type: 'updateDisabled', payload: Object.keys(choices) }
);
